export default "__VITE_ASSET__CkQd$rSs__"